// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AcoesMarketing_RestaurarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** InputContract for POST /marketing/acoes/restaurar/{id} — no body, the id travels in the URL. */
import { registerContract } from './validate'

export interface AcoesMarketing_RestaurarInput {}

registerContract('AcoesMarketing_RestaurarInput', {})
